export function can(user, permission) {
  const code = typeof user?.role === 'object' ? user.role.systemCode : user?.role
  if (code === 'ADMIN') return true
  return Array.isArray(user?.effectivePermissions) && user.effectivePermissions.includes(permission)
}
